export const musicCollection_8134 = {
    "@type": "Context",
    "id": 8134,
    "title": "Nederlandstalig",
    "description": "04",
    "lastChanged": null,
    "changeableParameter": [
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Music Tweak Style Feel",
            "metadataDisplayType": "TEXT_CHECKBOX_SELECTION",
            "metadataDisplayName": "Music Tweak Style Feel",
            "value": [
                {
                    "value": "Pop",
                    "selected": true
                },
                {
                    "value": "Rock",
                    "selected": true
                },
                {
                    "value": "Urban",
                    "selected": true
                }
            ]
        },
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Origin",
            "metadataDisplayType": "TEXT_CHECKBOX_SELECTION",
            "metadataDisplayName": "Origin",
            "value": [
                {
                    "value": "Belgium",
                    "selected": true
                },
                {
                    "value": "Netherlands",
                    "selected": true
                }
            ]
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "year",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "year",
            "minimum": 1966,
            "maximum": 2018,
            "step": 1,
            "lowerSelection": 1975,
            "upperSelection": 2018,
            "metadataDisplayMinimum": "-",
            "metadataDisplayMaximum": "+"
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "Region Popularity",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "Region Popularity",
            "minimum": 4,
            "maximum": 6,
            "step": 1,
            "lowerSelection": 4,
            "upperSelection": 6,
            "metadataDisplayMinimum": "4",
            "metadataDisplayMaximum": "6"
        },
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Mood",
            "metadataDisplayType": "TEXT_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "Mood",
            "value": [
                {
                    "value": "Peaceful",
                    "selected": false
                },
                {
                    "value": "Social",
                    "selected": true
                },
                {
                    "value": "Bright",
                    "selected": true
                },
                {
                    "value": "Dynamic",
                    "selected": false
                }
            ]
        }
    ],
    "defaultChangeableParameter": [
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Music Tweak Style Feel",
            "metadataDisplayType": "TEXT_CHECKBOX_SELECTION",
            "metadataDisplayName": "Music Tweak Style Feel",
            "value": [
                {
                    "value": "Pop",
                    "selected": true
                },
                {
                    "value": "Rock",
                    "selected": true
                },
                {
                    "value": "Urban",
                    "selected": true
                }
            ]
        },
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Origin",
            "metadataDisplayType": "TEXT_CHECKBOX_SELECTION",
            "metadataDisplayName": "Origin",
            "value": [
                {
                    "value": "Belgium",
                    "selected": true
                },
                {
                    "value": "Netherlands",
                    "selected": true
                }
            ]
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "year",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "year",
            "minimum": 1966,
            "maximum": 2018,
            "step": 1,
            "lowerSelection": 1966,
            "upperSelection": 2018,
            "metadataDisplayMinimum": "-",
            "metadataDisplayMaximum": "+"
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "Region Popularity",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "Region Popularity",
            "minimum": 4,
            "maximum": 6,
            "step": 1,
            "lowerSelection": 5,
            "upperSelection": 6,
            "metadataDisplayMinimum": "4",
            "metadataDisplayMaximum": "6"
        },
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Mood",
            "metadataDisplayType": "TEXT_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "Mood",
            "value": [
                {
                    "value": "Peaceful",
                    "selected": false
                },
                {
                    "value": "Social",
                    "selected": true
                },
                {
                    "value": "Bright",
                    "selected": true
                },
                {
                    "value": "Dynamic",
                    "selected": false
                }
            ]
        }
    ],
    "visible": true,
    "editable": false,
    "favourite": false,
    "selected": false,
    "mostPlayed": false,
    "defaultSelected": false
}